export const ID_DEVICE = 'ID_DEVICE';

export const MIXPANEL_EVENTS = {
  VISIT_AMOUNT: 'Visits Amount',
  SUBSCRIPTION: 'Subscribe',
  REGISTRATION: 'Registration',
};
